var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diff-container",attrs:{"translate":"no"}},_vm._l((_vm.diff),function({text, className},i){return _c('span',{key:i,class:'diff-chunk page_title ' + className + (_vm.isLines ? ' d-block' : '')},[_vm._v(_vm._s(text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }